// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3JVug","title":"FrontImage_title__3AWio"};